<template>
    <v-card v-if="exercise" flat tile :v-ripple="!readonly" class="pa-3">
        <v-row>
            <v-col cols="2" @click="goToDetail" class="pa-0">
                <div class="img-exercise" :style="{ backgroundImage: `url('${exerciseImg}')` }"></div>
            </v-col>
            <v-col cols="10" @click="goToDetail">
                <div class="name-duration-exercise text-truncate">
                    {{ exercise.name }}
                </div>
                <div>
                    <template v-if="showCompleteSets && dataSet">
                        <div v-if="dataSet.repsType && dataSet.repsType.data">
                            <v-icon x-small>{{ dataSet.repsType.icon }}</v-icon>
                            <span class="duration-exercise" v-html="dataSet.repsType.data"/>
                        </div>
                        <div v-if="dataSet.rpeType && dataSet.rpeType.data" class="duration-exercise">
                            <v-icon x-small>{{ dataSet.rpeType.icon }}</v-icon>
                            {{ dataSet.rpeType.data }}
                        </div>
                        <div v-if="dataSet.tempoType && dataSet.tempoType.data" class="duration-exercise">
                            <v-icon x-small>{{ dataSet.tempoType.icon }}</v-icon>
                            {{ dataSet.tempoType.data }}
                        </div>
                        <div v-if="dataSet.weight && dataSet.weight.data" class="duration-exercise">
                            <v-icon x-small>{{ dataSet.weight.icon }}</v-icon>
                            {{ dataSet.weight.data }}
                        </div>
                        <div v-if="dataSet.intensityType && dataSet.intensityType.data" class="duration-exercise">
                            <v-icon x-small>{{ dataSet.intensityType.icon }}</v-icon>
                            {{ dataSet.intensityType.data.replaceAll(':', '\'') }}
                        </div>
                    </template>
                    <div v-else class="duration-exercise">
                        {{ exerciseSets }} {{ exercise.eachSide ? `| ${$t('exercises.each_side')}` : '' }}
                    </div>
                </div>
                <div v-if="exercise.commentary" class="comment text-truncate">
                    {{ exercise.commentary }}
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>

import {db} from '@/utils/Firebase'

export default {
    props: {
        exercise: {
            type: Object,
            default: null,
        },
        block: {
            type: Number,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false
        },
        showCompleteSets: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            dataSet: null,
        }
    },
    computed: {
        assignedRoutineId(vm = this) {
            return vm.$route.params.uid
        },
        sets() {
            const vm = this
            return vm.exercise?.config?.sets || []
        },
        exerciseImg() {
            const vm = this
            return vm.exercise?.img || vm.exercise?.video?.thumb || vm.imgPlaceholder
        },
        exerciseSets() {
            const vm = this
            let config = vm.exercise.config || null
            if (!config) return vm.$t('common.not_available_short')
            let quantitySets = config.sets.length
            let type = vm.$t(`exercises.${config.sets[0].data[0].short_name}`)

            let result = ''

            if (quantitySets === 1) {
                result = `${quantitySets}x${config.sets[0].data[0].value}${type}`
            } else {
                let values = []
                let current = null
                let sameValue = true
                config.sets.forEach(set => {
                    if (!current) current = set.data[0].value
                    values.push(set.data[0].value)
                    if (current !== set.data[0].value) sameValue = false
                    current = set.data[0].value
                })

                if (sameValue) {
                    result = `${quantitySets}x${values[0]}${type}`
                } else {
                    result = `${quantitySets}x${values.join(`${type},`)}${type}`
                }
            }
            return result
        },
        hasIntensity(vm = this) {
            return !!vm.exercise?.categories?.find(category => category === 'Velocidad' || category === 'Resistencia')
        }
    },
    mounted() {
        const vm = this
        vm.setData()
    },
    methods: {
        goToDetail() {
            const vm = this
            return vm.readonly ?
                vm.$emit('click:showExercise') :
                vm.$emit('click:goToExercise', vm.exercise.id)
        },
        setData() {
            const vm = this
            let data = {
                repsType: null,
                rpeType: null,
                tempoType: null,
                weight: null,
                intensity: null,
                micropause: null,
            }
            vm.sets.forEach((set, i) => {
                if (i === 0) {
                    // INITIALIZE
                    let repsType = null
                    if (vm.hasIntensity) {
                        repsType = set.data && set.data.find(data =>
                            data.name === vm.$t('exercises.reps') || data.name === vm.$t('exercises.distance'))
                    } else {
                        repsType = set.data && set.data.find(data =>
                            data.name === vm.$t('exercises.reps') || data.name === vm.$t('exercises.time') ||
                            data.name === vm.$t('exercises.distance'))
                    }
                    if (repsType) data.repsType = {data: '', icon: repsType.icon, short_name: repsType.short_name}
                    let rpeType = set.data && set.data.find(data =>
                        data.name === vm.$t('exercises.rpe') || data.name === vm.$t('exercises.percentage') ||
                        data.name === vm.$t('exercises.rir') || data.name === vm.$t('exercises.meter_seconds'))
                    if (rpeType) data.rpeType = {data: '', icon: rpeType.icon, short_name: rpeType.short_name}
                    let tempoType = set.data && set.data.find(data => data.name === vm.$t('exercises.tempo') || data.name === vm.$t('exercises.additional'))
                    if (tempoType) data.tempoType = {data: '', icon: tempoType.icon, short_name: tempoType.short_name}
                    let weight = set.data && set.data.find(data => data.name === vm.$t('exercises.weight'))
                    if (weight && !!weight.value) data.weight = {
                        data: '',
                        icon: weight.icon,
                        short_name: weight.short_name
                    }
                    let intensityType = set.data && set.data.find(data => data.name === vm.$t('exercises.beat_min') || data.name === vm.$t('exercises.time_km') ||
                        data.name === vm.$t('exercises.rpe') || data.name === vm.$t('exercises.time'))
                    if (intensityType && vm.hasIntensity) data.intensityType = {
                        data: '',
                        icon: intensityType.icon,
                        short_name: intensityType.short_name
                    }
                    let micropause = set.data && set.data.find(data => data.name === vm.$t('exercises.micropause'))
                    if (micropause) data.micropause = {
                        data: '',
                        icon: micropause.icon,
                        short_name: micropause.short_name
                    }
                }

                let separation = vm.sets.length > i + 1 ? '| ' : ''

                if (data.repsType) {
                    let valueReps = set.data && set.data.find(d => d.short_name === data.repsType.short_name).value
                    if (data.micropause) {
                        let valueMp = set.data && set.data.find(d => d.short_name === data.micropause.short_name).value + ""
                        let stringReps = `${valueReps}${vm.$t(`exercises.${data.repsType.short_name}`)}`
                        let stringMp = valueMp === "0" || valueMp === "" || valueMp === "00:00" ? '' : `${valueMp}${vm.$t(`exercises.${data.micropause.short_name}`)}`
                        data.repsType.data += `${stringReps} <sup>${stringMp}</sup> ${separation}`
                    } else {
                        data.repsType.data += `${valueReps}${vm.$t(`exercises.${data.repsType.short_name}`)} ${separation}`
                    }
                }

                if (data.rpeType) {
                    let valueRpe = set.data && set.data.find(d => d.short_name === data.rpeType.short_name).value + ""
                    if (valueRpe !== "0" && (data.rpeType.short_name === 'short_rpe' || data.rpeType.short_name === 'short_rir')) {
                        data.rpeType.data += `(${valueRpe}) ${separation}`
                    } else if (valueRpe !== "0") {
                        data.rpeType.data += `${valueRpe}${vm.$t(`exercises.${data.rpeType.short_name}`)} ${separation}`
                    }
                }

                if (data.tempoType) {
                    let valueTempo = set.data && set.data.find(d => d.short_name === data.tempoType.short_name).value + ""
                    if (valueTempo !== "0") data.tempoType.data += `${valueTempo}${vm.$t(`exercises.${data.tempoType.short_name}`)} ${separation}`
                }

                if (data.weight) {
                    let weight = set.data && set.data.find(d => d.short_name === data.weight.short_name).value + ""
                    if (weight !== "0") data.weight.data += `${weight}${vm.$t(`exercises.${data.weight.short_name}`)} ${separation}`
                }

                if (data.intensityType) {
                    let valueIntensity = set.data && set.data.find(d => d.short_name === data.intensityType.short_name).value + ""
                    if (valueIntensity !== "0") data.intensityType.data += `${valueIntensity}${vm.$t(`exercises.${data.intensityType.short_name}`)} ${separation}`
                }

                if (data.micropause && data.repsType?.short_name !== 'short_reps') {
                    let valueMicropause = set.data && set.data.find(d => d.short_name === data.micropause.short_name).value + ""
                    if (valueMicropause !== "0") data.micropause.data += `${valueMicropause}${vm.$t(`exercises.${data.micropause.short_name}`)} ${separation}`
                }

            })

            vm.dataSet = data
        }
    },
    watch: {
        sets() {
            this.setData()
        },
    }
}
</script>

<style scoped>

.name-duration-exercise {
    font-size: 13px !important;
    line-height: 18px;
    color: #707070;
}

.duration-exercise {
    font-size: 10px !important;
    line-height: 16px;
    color: #333333;
}

.comment {
    text-align: center;
    font-size: 10px;
    color: #707070;
    border: 1px solid #707070;
    border-radius: 4px;
    padding: 0 4px;
    cursor: pointer;
}

.img-exercise {
    background-position: 50% 50%;
    background-size: cover;
    background-color: rgba(1, 55, 46, 0.07);
    height: calc(100% + 1px);
    border-radius: 4px 0 0 4px;
}

</style>